import { Nullable } from '@dai/common'
import { isNil } from 'lodash'

import { Colors } from '@/components/Colors'
import { BoundingBoxFragment } from '@/graphql'

type ProductPreferredNameSource = {
  preferredName?: string | null
  name?: string | null
  upcA?: string | null
}

const getProductPreferredName = (
  product?: ProductPreferredNameSource | null,
  fallbackUpc?: string | null,
) => {
  return product?.preferredName || product?.name || fallbackUpc || null
}

const EMPTY_SLOT_UPC = '000000000018'
const PRICING_UPC = '000000000017'
const UNKNOWN_UPC = '000000000002'

const RESTOCK_DETAIL_UPCS_TO_IGNORE = [PRICING_UPC]

const filterRestockBoxes = (restockBoxes: BoundingBoxFragment[]) => {
  return restockBoxes.filter(restockBox => {
    const { classifiedLabel, detectedLabel } = restockBox
    return (
      !RESTOCK_DETAIL_UPCS_TO_IGNORE.includes(classifiedLabel || '') &&
      !RESTOCK_DETAIL_UPCS_TO_IGNORE.includes(detectedLabel)
    )
  })
}

const filterProductBoxes = (restockBoxes: BoundingBoxFragment[]) => {
  return restockBoxes.filter(restockBox => {
    const { classifiedLabel, detectedLabel } = restockBox
    return (
      ![PRICING_UPC, EMPTY_SLOT_UPC].includes(classifiedLabel || '') &&
      ![PRICING_UPC, EMPTY_SLOT_UPC].includes(detectedLabel)
    )
  })
}

const filterIdentifiedProductBoxes = (restockBoxes: BoundingBoxFragment[]) => {
  return restockBoxes.filter(restockBox => {
    const { classifiedLabel, detectedLabel } = restockBox
    return (
      !isNil(classifiedLabel) &&
      ![PRICING_UPC, EMPTY_SLOT_UPC, UNKNOWN_UPC].includes(
        classifiedLabel || '',
      ) &&
      ![PRICING_UPC, EMPTY_SLOT_UPC].includes(detectedLabel)
    )
  })
}

const getEmptyBoxes = (restockBoxes: BoundingBoxFragment[]) => {
  return restockBoxes.filter(restockBox => {
    const { classifiedLabel, detectedLabel } = restockBox
    return (
      classifiedLabel === EMPTY_SLOT_UPC || detectedLabel === EMPTY_SLOT_UPC
    )
  })
}

const getBoundingBoxColor = (upc: Nullable<string>) => {
  if (!upc || upc === UNKNOWN_UPC) {
    return Colors.UNIDENTIFIED
  }
  if (upc && upc === EMPTY_SLOT_UPC) {
    return Colors.OOS
  }
  if (upc && upc === PRICING_UPC) {
    return 'orange'
  }
  return '#2894ff' // blue
}

export const ProductHelpers = {
  getEmptyBoxes,
  filterRestockBoxes,
  getBoundingBoxColor,
  filterProductBoxes,
  filterIdentifiedProductBoxes,
  getProductPreferredName,
  EMPTY_SLOT_UPC,
  PRICING_UPC,
  UNKNOWN_UPC,
}
